export function hasPermission(permissions, resource, action) {
  return (permissions ?? []).some(
    (p) => p.resource === resource && p.action === action,
  )
}

export function getScopesForResource(permissions, resource) {
  const scopes = (permissions ?? [])
    .filter((p) => p.resource === resource)
    .map((p) => p.scope)
  return [...new Set(scopes)]
}

export function getEffectiveScope(
  scopesForResource,
  pendingScopes,
  resource,
  permissionOptions,
  fallback = '',
) {
  return (
    scopesForResource[0] ??
    pendingScopes[resource] ??
    permissionOptions?.scopes[0] ??
    fallback
  )
}
